import React, { Suspense, lazy } from 'react';

import { Route, Switch } from 'react-router-dom';
import styled from 'styled-components';

import Loader from 'Components-redesign/Loader';
import AdyenReports from 'Scenes/Adyen/Reports';
import Beepers from 'Scenes/Beepers';
import Releases from 'Scenes/Releases';
import ReleaseForm from 'Scenes/Releases/Components/FeatureForm';
import Cash from 'Scenes-redesign/Cash';
import StaffExtractor from 'Scenes-redesign/StaffExtractor';

import { retry } from './utils';

const Membership = lazy(() => retry(() => import('Scenes/Membership')));
const Variations = lazy(() => retry(() => import('Scenes/Variations')));
const CreateOrEditVariation = lazy(() => retry(() => import('Scenes/Variations/Edit')));
const VariationGroup = lazy(() => retry(() => import('Scenes/VariationGroups')));
const AddDevices = lazy(() => retry(() => import('Scenes-redesign/DeviceSettings')));
const CreateOrEditVariationGroup = lazy(() => retry(() => import('Scenes/VariationGroups/Edit')));
const Tables = lazy(() => retry(() => import('Scenes/Tables')));
const Floorplans = lazy(() => retry(() => import('Scenes/Floorplans')));
const CreateOrEditFloorplan = lazy(() => retry(() => import('Scenes/Floorplans/Edit')));
const ReceiptTemplates = lazy(() => retry(() => import('Scenes/ReceiptTemplates')));
const CreateOrEditReceiptTemplate = lazy(() => retry(() => import('Scenes/ReceiptTemplates/Edit')));
const Delivery = lazy(() => retry(() => import('Scenes/Delivery')));
const CreateOrEditDelivery = lazy(() => retry(() => import('Scenes/Delivery/Edit')));
const Items = lazy(() => retry(() => import('Scenes/Items')));
const AdyenTransactions = lazy(() => retry(() => import('Scenes/Adyen/Transactions')));
const Admins = lazy(() => retry(() => import('Scenes/Admins')));
const Points = lazy(() => retry(() => import('Scenes/Points')));
const Insights = lazy(() => retry(() => import('Scenes/Insights')));
const Marketplaces = lazy(() => retry(() => import('Scenes/Marketplaces')));
const OnlineOrdering = lazy(() => retry(() => import('Scenes/OnlineOrdering')));
const Categories = lazy(() => retry(() => import('Scenes/Categories')));
const CreateOrEditCategory = lazy(() => retry(() => import('Scenes/Categories/Edit')));
const PredefinedMessages = lazy(() => retry(() => import('Scenes/PredefinedMessages')));
const CreateOrEditMessage = lazy(() => retry(() => import('Scenes/PredefinedMessages/Edit')));
const Courses = lazy(() => retry(() => import('Scenes/Courses')));
const CreateOrEditCourse = lazy(() => retry(() => import('Scenes/Courses/Edit')));
const CreateOrEditMenu = lazy(() => retry(() => import('Scenes/Menus/Edit')));
const CreateOrEditUser = lazy(() => retry(() => import('Scenes/Users/Edit')));
const CreateOrEditMembership = lazy(() => retry(() => import('Scenes/Membership/Edit')));
const UpdateMemberships = lazy(() => retry(() => import('Scenes/Membership/Update')));
const StaffReport = lazy(() => retry(() => import('Scenes/StaffReport')));
const Menus = lazy(() => retry(() => import('Scenes/Menus')));
const VenuesOld = lazy(() => retry(() => import('Scenes/Venues')));
const Devices = lazy(() => retry(() => import('Scenes/Devices')));
const Printers = lazy(() => retry(() => import('Scenes/Printers')));
const Offers = lazy(() => retry(() => import('Scenes/Offers')));
const SignupCodes = lazy(() => retry(() => import('Scenes/SignupCodes')));
const Segments = lazy(() => retry(() => import('Scenes/Segments')));
const Contents = lazy(() => retry(() => import('Scenes/Contents')));
const Companies = lazy(() => retry(() => import('Scenes-redesign/Companies')));
const DataExtractor = lazy(() => retry(() => import('Scenes/DataExtractor')));
const StampCards = lazy(() => retry(() => import('Scenes/StampCards')));
const NotificationLogs = lazy(() => retry(() => import('Scenes/NotificationLogs')));
const Users = lazy(() => retry(() => import('Scenes/Users/view')));
const CreateAdminUser = lazy(() => retry(() => import('Scenes/Users/CreateAdmin')));
const ShoppingCartExplorer = lazy(() => retry(() => import('Scenes/Explorer/ShoppingCarts')));
const AppPosReport = lazy(() => retry(() => import('Scenes-redesign/AppPosReport')));
const POSItemReport = lazy(() => retry(() => import('Scenes-redesign/POSItemReport')));
const FortnoxReport = lazy(() => retry(() => import('Scenes-redesign/FortnoxReport')));
const OrdersReport = lazy(() => retry(() => import('Scenes-redesign/OrdersReport')));
const ZReports = lazy(() => retry(() => import('Scenes-redesign/ZReports')));
const ZReportsDebug = lazy(() => retry(() => import('Scenes/Explorer/Reports')));
const Orders = lazy(() => retry(() => import('Scenes-redesign/Orders')));
const Integrations = lazy(() => retry(() => import('Scenes/Integrations')));
const IntegrationConfigs = lazy(() => retry(() => import('Scenes/IntegrationConfigs')));
const SendVouchers = lazy(() => retry(() => import('Scenes/SendVouchers')));
const CreateUser = lazy(() => retry(() => import('Scenes/Users/Create')));
const AdyenPayouts = lazy(() => retry(() => import('Scenes/Adyen/Payouts')));
const CreateOrEditOffer = lazy(() => retry(() => import('Scenes/Offers/Edit')));
const CreateOrEditDevice = lazy(() => retry(() => import('Scenes/Devices/Edit')));
const CreateOrEditSignupCode = lazy(() => retry(() => import('Scenes/SignupCodes/Edit')));
const CreateOrEditContent = lazy(() => retry(() => import('Scenes/Contents/Edit')));
const CreateOrEditStampCard = lazy(() => retry(() => import('Scenes/StampCards/Edit')));
const CreateOrEditVenue = lazy(() => retry(() => import('Scenes/Venues/Edit')));
const CreateOrEditItem = lazy(() => retry(() => import('Scenes/Items/Edit')));
const EditCompany = lazy(() => retry(() => import('Scenes/Companies/Edit')));
const BankingDashboard = lazy(() => retry(() => import('Scenes/BankingDashboard')));
const CreateCompany = lazy(() => retry(() => import('Scenes/Companies/Create')));
const OnlineVenues = lazy(() => retry(() => import('Scenes/Online')));
const Home = lazy(() => retry(() => import('Scenes/Home')));
const OpenHours = lazy(() => retry(() => import('Scenes/OpenHours')));
const EditOpenHours = lazy(() => retry(() => import('Scenes/OpenHours/Edit')));
const OpeningHours = lazy(() => retry(() => import('Scenes-redesign/OpeningHours')));
const Stations = lazy(() => retry(() => import('Scenes/Stations')));
const CreateOrEditStations = lazy(() => retry(() => import('Scenes/Stations/Edit')));
const Notifications = lazy(() => retry(() => import('Scenes/Notifications')));
const NewDashboard = lazy(() => retry(() => import('Scenes-redesign/Dashboard')));
const OrderCreator = lazy(() => retry(() => import('Scenes/Tools/OrderCreator')));
const TableService = lazy(() => retry(() => import('Scenes/Tools/TableService')));
const GeneratedReports = lazy(() => retry(() => import('Scenes/GeneratedReports')));
const Terminals = lazy(() => retry(() => import('Scenes/Terminals')));
const Payments = lazy(() => retry(() => import('Scenes/Adyen/Payments')));
const ScheduledOffer = lazy(() => retry(() => import('Scenes/ScheduledOffer')));
const ScheduledOfferWizard = lazy(() => retry(() => import('Scenes/ScheduledOffer/wizard')));
const CreateOrEditScheduledOffer = lazy(() => retry(() => import('Scenes/ScheduledOffer/Edit')));
const UserAnalytics = lazy(() => retry(() => import('Scenes/UserAnalytics')));
const SendCSV = lazy(() => retry(() => import('Scenes/SendCSV')));
const SendExcel = lazy(() => retry(() => import('Scenes/SendExcel')));
const Layouts = lazy(() => retry(() => import('Scenes/Layouts')));
const CreateOrEditLayout = lazy(() => retry(() => import('Scenes/Layouts/Edit')));
const PosCategories = lazy(() => retry(() => import('Scenes/PosCategories')));
const CreateOrEditPosCategory = lazy(() => retry(() => import('Scenes/PosCategories/Edit')));
const Pages = lazy(() => retry(() => import('Scenes/Pages')));
const CreateOrEditPage = lazy(() => retry(() => import('Scenes/Pages/Edit')));
const AccessLevel = lazy(() => retry(() => import('Scenes/AccessLevels')));
const CreateOrEditAccessLevel = lazy(() => retry(() => import('Scenes/AccessLevels/Edit')));
const Staff = lazy(() => retry(() => import('Scenes/Staff')));
const AdyenAccountHolders = lazy(() => retry(() => import('Scenes/Adyen/AccountHolders')));
const BalanceOnboarding = lazy(() => retry(() => import('Scenes/Adyen/BalanceOnboarding')));
const CreateOrEditStaff = lazy(() => retry(() => import('Scenes/Staff/Edit')));
const ExpressPages = lazy(() => retry(() => import('Scenes/ExpressPages')));
const CreateOrEditExpressPage = lazy(() => retry(() => import('Scenes/ExpressPages/Edit')));
const Upsells = lazy(() => retry(() => import('Scenes/Upsells')));
const CreateOrEditUpsell = lazy(() => retry(() => import('Scenes/Upsells/Edit')));
const PaymentMethodsOld = lazy(() => retry(() => import('Scenes/PaymentMethods')));
const CreateOrEditPaymentMethod = lazy(() => retry(() => import('Scenes/PaymentMethods/Edit')));
const MenuEditor = lazy(() => retry(() => import('Scenes/MenuEditor')));
const InventoryExplorer = lazy(() => retry(() => import('Scenes/Explorer/Inventory')));
const ReportsExplorer = lazy(() => retry(() => import('Scenes/Explorer')));
const TablesExplorer = lazy(() => retry(() => import('Scenes/Explorer/Tables')));
const OrderStatusExplorer = lazy(() => retry(() => import('Scenes/Explorer/OrderStatus')));
const Zones = lazy(() => retry(() => import('Scenes/Zones')));
const CreateOrEditZone = lazy(() => retry(() => import('Scenes/Zones/Edit')));
const LoadingPage = lazy(() => retry(() => import('Scenes/LoadingPage')));
const SplitConfigs = lazy(() => retry(() => import('Scenes/Adyen/SplitConfigs')));
const SuperAdminCompanyHome = lazy(() =>
  retry(() => import('Scenes-redesign/SuperAdminCompanyHome')),
);
const ChoiceInviteCodes = lazy(() => retry(() => import('Scenes-redesign/ChoiceInviteCodes')));

const PrivateRoute = lazy(() => retry(() => import('./PrivateRoute')));

//REDESIGN
const PIM = lazy(() => retry(() => import('Scenes-redesign/PIM')));
const POS = lazy(() => retry(() => import('Scenes-redesign/POS')));
const Revenue = lazy(() => retry(() => import('Scenes-redesign/Revenue')));

const Venues = lazy(() => retry(() => import('Scenes-redesign/Venues')));
const FourOhFour = lazy(() => retry(() => import('Scenes-redesign/FourOhFour')));
const Members = lazy(() => retry(() => import('Scenes-redesign/Members')));
const IntegrationErrors = lazy(() => retry(() => import('Scenes-redesign/Errors/Integrations')));
const InvalidOrders = lazy(() => retry(() => import('Scenes-redesign/Errors/InvalidOrders')));
const InvalidRefunds = lazy(() => retry(() => import('Scenes-redesign/Errors/InvalidRefunds')));
const Onboarding = lazy(() => retry(() => import('Scenes-redesign/Onboarding')));
const NewIntegrations = lazy(() => retry(() => import('Scenes-redesign/Integrations')));
const Vouchers = lazy(() => retry(() => import('Scenes-redesign/Integrations/Vouchers')));
const Invoices = lazy(() => retry(() => import('Scenes-redesign/Integrations/Invoices')));
const Payouts = lazy(() => retry(() => import('Scenes-redesign/Payouts')));
const AddLocations = lazy(() => retry(() => import('Scenes-redesign/AddLocations')));
const GiftCardsDashboard = lazy(() => retry(() => import('Scenes-redesign/GiftCards/Dashboard')));
const GiftCardsReport = lazy(() => retry(() => import('Scenes-redesign/GiftCards/Report')));
const GiftCardsAdmin = lazy(() => retry(() => import('Scenes-redesign/GiftCards/Admin')));
const PaymentMethods = lazy(() => retry(() => import('Scenes-redesign/PaymentMethods')));
const Ingredients = lazy(() => retry(() => import('Scenes-redesign/Ingredients')));
const QuicksightNamespaces = lazy(() =>
  retry(() => import('Scenes-redesign/Quicksight/Namespaces')),
);
const QuicksightAccessRights = lazy(() =>
  retry(() => import('Scenes-redesign/Quicksight/AccessRights')),
);
const Licenses = lazy(() => retry(() => import('Scenes/LicenseRoute')));
const MigrateLicenses = lazy(() =>
  retry(() => import('Scenes-redesign/LicensesAdmin/MigrateLicenses')),
);
const ManageDevices = lazy(() =>
  retry(() => import('Scenes-redesign/Licenses/Components/ManageDevices')),
);
const LoginLink = lazy(() => retry(() => import('Scenes-redesign/LoginLink')));
const PromoCodes = lazy(() => retry(() => import('Scenes-redesign/PromoCodes')));
const GStock = lazy(() => retry(() => import('Scenes-redesign/GStock')));
const Graveyard = lazy(() => retry(() => import('Scenes-redesign/Graveyard')));
const CloudPrintDebug = lazy(() => retry(() => import('Scenes-redesign/CloudPrintDebug')));
const Personalkollen = lazy(() => retry(() => import('Scenes-redesign/Personalkollen')));
const AdyenTransactionsInspector = lazy(() =>
  retry(() => import('Scenes-redesign/AdyenTransactionsInspector')),
);
const AdyenPayoutsInspector = lazy(() =>
  retry(() => import('Scenes-redesign/AdyenPayoutsInspector')),
);
const DiffFinderTool = lazy(() => retry(() => import('Scenes-redesign/DiffFinderTool')));
const DataComparison = lazy(() => retry(() => import('Scenes-redesign/DataComparison')));
const VoucherComparison = lazy(() => retry(() => import('Scenes-redesign/VoucherComparison')));
const CompaniesTable = lazy(() => retry(() => import('Scenes-redesign/CompaniesTable')));
const ManualUserActivation = lazy(() =>
  retry(() => import('Scenes-redesign/ManualUserActivation')),
);
const MenusSelect = lazy(() => retry(() => import('Scenes-redesign/Menus')));
const OnboardingMonitoring = lazy(() =>
  retry(() => import('Scenes-redesign/OnboardingMonitoring')),
);
const CreateCompanyOnboarding = lazy(() => retry(() => import('Scenes-redesign/CreateCompany')));
const CreateCompanyForm = lazy(() =>
  retry(() => import('Scenes-redesign/CreateCompany/Components/NewCustomer')),
);
const Organizations = lazy(() => retry(() => import('Scenes-redesign/Organizations')));
const AnalyticsImport = lazy(() => retry(() => import('Scenes-redesign/AnalyticsImport')));
const MigrateLicensesStatus = lazy(() => retry(() => import('Scenes/MigrateLicensesStatus')));
const MembershipDiscountToggle = lazy(() => retry(() => import('Scenes/MembershipDiscountToggle')));

const Loading = styled.div`
  flex: 1;
  padding: 200px 0;
  width: 100%;
  align-items: center;
  display: flex;
  justify-content: center;
`;

const Routes = () => {
  return (
    <Suspense
      fallback={
        <Loading>
          <Loader color="#1C232C" />
        </Loading>
      }>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/loading" component={LoadingPage} />

        {/* BI */}
        <Route exact path="/dashboard" component={NewDashboard} />

        {/* APP - Routes accessible if company hasApp */}
        <Route exact path="/app/memberships" component={Membership} />
        <Route path="/app/memberships/update" component={UpdateMemberships} />
        <Route path="/app/memberships/create" component={CreateOrEditMembership} />
        <Route path="/app/memberships/edit/:id" component={CreateOrEditMembership} />
        <Route exact path="/app/assign-points" component={Points} />
        <Route exact path="/users" component={Users} />
        <Route exact path="/app/users" component={Users} />
        <Route exact path="/app/users/create" component={CreateUser} />
        <Route path="/users/edit/:id" component={CreateOrEditUser} />
        <Route path="/users/analytics/:id" component={UserAnalytics} />
        <Route path="/app/send-csv" component={SendCSV} />
        <Route path="/app/send-excel" component={SendExcel} />
        <Route path="/app/shopping-carts" component={ShoppingCartExplorer} />
        <Route exact path="/app/members" component={Members} />
        <Route exact path="/app/members/:id" component={Members} />

        {/* Engagement */}
        <Route exact path="/offers" component={Offers} />
        <Route path="/offers/create" component={CreateOrEditOffer} />
        <Route path="/offers/edit/:id" component={CreateOrEditOffer} />
        <Route exact path="/stampcards" component={StampCards} />
        <Route path="/stampcards/create" component={CreateOrEditStampCard} />
        <Route path="/stampcards/edit/:id" component={CreateOrEditStampCard} />
        <Route exact path="/campaigns" component={ScheduledOffer} />
        <Route path="/campaigns/create" component={CreateOrEditScheduledOffer} />
        <Route path="/campaigns/edit/:id" component={CreateOrEditScheduledOffer} />
        <Route path="/campaigns/wizard" component={ScheduledOfferWizard} />
        <Route exact path="/signupcodes" component={SignupCodes} />
        <Route path="/signupcodes/create" component={CreateOrEditSignupCode} />
        <Route path="/signupcodes/edit/:id" component={CreateOrEditSignupCode} />
        <Route exact path="/promocodes" component={PromoCodes} />
        <Route exact path="/promocodes/:id" component={PromoCodes} />
        <Route exact path="/notifications" component={Notifications} />
        <Route exact path="/segments" component={Segments} />
        <Route path="/segments/:id" component={Segments} />
        <Route path="/insights" component={Insights} />

        {/* Gift cards */}
        <Route exact path="/gift-cards-beta" component={GiftCardsDashboard} />

        <Route exact path="/gift-cards-beta/reports" component={GiftCardsReport} />
        <Route path="/gift-cards-beta/:shortcode" component={GiftCardsDashboard} />
        <Route exact path="/gift-cards/admin" component={GiftCardsAdmin} />

        {/* Store */}
        <Route exact path="/legacy-venues" component={VenuesOld} />
        <Route path="/legacy-venues/create" component={CreateOrEditVenue} />
        <Route path="/legacy-venues/edit/:id" component={CreateOrEditVenue} />
        <Route exact path="/venues" component={Venues} />
        <Route path="/venues/:id" component={Venues} />
        <Route path="/menus-select" component={MenusSelect} />
        <Route exact path="/opening-hours" component={OpeningHours} />
        <Route exact path="/receiptTemplates" component={ReceiptTemplates} />
        <Route exact path="/receiptTemplates/edit/:id" component={CreateOrEditReceiptTemplate} />
        <Route exact path="/receiptTemplates/create" component={CreateOrEditReceiptTemplate} />
        <Route path="/legacy-payment-methods/create" component={CreateOrEditPaymentMethod} />
        <Route path="/legacy-payment-methods/edit/:id" component={CreateOrEditPaymentMethod} />
        <Route path="/legacy-payment-methods" component={PaymentMethodsOld} />
        <Route exact path="/payment-methods" component={PaymentMethods} />
        <Route path="/payment-methods/:id" component={PaymentMethods} />
        <Route exact path="/beepers" component={Beepers} />
        <Route exact path="/cash" component={Cash} />
        <Route exact path="/deliveries" component={Delivery} />
        <Route path="/deliveries/edit/:id" component={CreateOrEditDelivery} />
        <Route path="/deliveries/create" component={CreateOrEditDelivery} />
        <Route exact path="/contents" component={Contents} />
        <Route path="/contents/create" component={CreateOrEditContent} />
        <Route path="/contents/edit/:id" component={CreateOrEditContent} />

        {/* TSR - Routes accessible if company hasTables */}
        <Route exact path="/tsr/zones" component={Zones} />
        <Route exact path="/tsr/zones/create" component={CreateOrEditZone} />
        <Route exact path="/tsr/zones/edit/:id" component={CreateOrEditZone} />
        <Route exact path="/tsr/monitoring" component={TablesExplorer} />
        <Route exact path="/tsr/tables" component={Tables} />
        <Route exact path="/tsr/floorplans" component={Floorplans} />
        <Route exact path="/tsr/floorplans/create" component={CreateOrEditFloorplan} />
        <Route exact path="/tsr/floorplans/edit/:id" component={CreateOrEditFloorplan} />
        <Route exact path="/tsr/messages" component={PredefinedMessages} />
        <Route path="/tsr/messages/create" component={CreateOrEditMessage} />
        <Route path="/tsr/messages/edit/:id" component={CreateOrEditMessage} />

        {/* POS - Routes accessible if company hasPos */}
        <Route exact path="/pos" component={POS} />
        <Route exact path="/layouts" component={Layouts} />
        <Route exact path="/layouts/edit/:id" component={CreateOrEditLayout} />
        <Route exact path="/layouts/create" component={CreateOrEditLayout} />
        <Route exact path="/posCategories" component={PosCategories} />
        <Route exact path="/posCategories/edit/:id" component={CreateOrEditPosCategory} />
        <Route exact path="/posCategories/create" component={CreateOrEditPosCategory} />
        <Route exact path="/pages" component={Pages} />
        <Route exact path="/pages/edit/:id" component={CreateOrEditPage} />
        <Route exact path="/pages/create" component={CreateOrEditPage} />

        {/* KDS - Routes accesible if company hasKDS */}
        <Route exact path="/kds/explorer" component={OrderStatusExplorer} />

        <Route exact path="/super-admin-tools" component={SuperAdminCompanyHome} />

        {/* PIM */}
        <Route exact path="/pim" component={PIM} />
        <Route exact path="/pim/:path" component={PIM} />
        <Route exact path="/pim/:path/:id" component={PIM} />
        <Route exact path="/categories" component={Categories} />
        <Route path="/categories/create" component={CreateOrEditCategory} />
        <Route path="/categories/edit/:id" component={CreateOrEditCategory} />
        <Route exact path="/stations" component={Stations} />
        <Route path="/stations/create" component={CreateOrEditStations} />
        <Route path="/stations/edit/:id" component={CreateOrEditStations} />
        <Route exact path="/menus" component={Menus} />
        <Route path="/menus/create" component={CreateOrEditMenu} />
        <Route path="/menus/edit/:id" component={CreateOrEditMenu} />
        <Route exact path="/variations" component={Variations} />
        <Route exact path="/variations/edit/:id" component={CreateOrEditVariation} />
        <Route exact path="/variations/create" component={CreateOrEditVariation} />
        <Route exact path="/variationGroups" component={VariationGroup} />
        <Route exact path="/variationGroups/edit/:id" component={CreateOrEditVariationGroup} />
        <Route exact path="/variationGroups/create" component={CreateOrEditVariationGroup} />
        <Route exact path="/items" component={Items} />
        <Route path="/items/create" component={CreateOrEditItem} />
        <Route path="/items/edit/:id" component={CreateOrEditItem} />
        <Route path="/upsells/create" component={CreateOrEditUpsell} />
        <Route path="/upsells/edit/:id" component={CreateOrEditUpsell} />
        <Route path="/upsells" component={Upsells} />
        <Route exact path="/messages" component={PredefinedMessages} />
        <Route path="/messages/create" component={CreateOrEditMessage} />
        <Route path="/messages/edit/:id" component={CreateOrEditMessage} />
        <Route exact path="/coursetypes" component={Courses} />
        <Route path="/coursetypes/create" component={CreateOrEditCourse} />
        <Route path="/coursetypes/edit/:id" component={CreateOrEditCourse} />
        <Route path="/menu-editor" component={MenuEditor} />

        {/* Ingredients */}
        <Route exact path="/ingredients-beta" component={Ingredients} />
        <Route path="/ingredients-beta/:id" component={Ingredients} />

        {/* Express - Routes accessible if company hasExpress */}
        <Route path="/express-pages/create" component={CreateOrEditExpressPage} />
        <Route path="/express-pages/edit/:id" component={CreateOrEditExpressPage} />
        <Route path="/express-pages" component={ExpressPages} />

        {/* Inventory - Routes accessible if company hasInventory */}
        <Route exact path="/inventory" component={InventoryExplorer} />

        {/* Orders */}
        <Route exact path="/orders" component={Orders} />

        {/* Online */}
        <Route exact path="/online" component={OnlineVenues} />
        <Route exact path="/online-ordering" component={OnlineOrdering} />

        {/* Quicksight */}
        <Route exact path="/quicksight/namespaces" component={QuicksightNamespaces} />
        <Route path="/quicksight/namespaces/:formcode" component={QuicksightNamespaces} />
        <Route exact path="/quicksight/access-rights" component={QuicksightAccessRights} />
        <Route path="/quicksight/access-rights/:formcode" component={QuicksightAccessRights} />

        {/* Adyen */}
        <Route path="/adyen/account-holders" component={AdyenAccountHolders} />
        <Route path="/adyen/balance-onboarding" component={BalanceOnboarding} />
        <Route path="/adyen/payments" component={Payments} />
        <Route path="/transactions-list" component={AdyenTransactions} />
        <Route path="/adyen/terminals" component={Terminals} />
        <Route exact path="/transactions/reports" component={AdyenReports} />
        <Route exact path="/adyen/split-configs" component={SplitConfigs} />
        <Route path="/adyen/split-configs/:name" component={SplitConfigs} />
        <Route exact path="/payouts" component={AdyenPayouts} />
        <Route exact path="/diff-finder-tool" component={DiffFinderTool} />

        {/* Reports */}
        <Route exact path="/reports" component={GeneratedReports} />
        <Route exact path="/app-pos-report" component={AppPosReport} />
        <Route exact path="/z-reports" component={ZReports} />
        <Route exact path="/z-reports/debug" component={ZReportsDebug} />
        <Route exact path="/pos-item-report" component={POSItemReport} />
        <Route exact path="/fortnox-report" component={FortnoxReport} />
        <Route exact path="/orders-report" component={OrdersReport} />

        {/* Staff */}
        <Route exact path="/admins" component={Admins} />
        <Route path="/admins/create" component={CreateAdminUser} />
        <Route exact path="/access-levels" component={AccessLevel} />
        <Route exact path="/access-levels/edit/:id" component={CreateOrEditAccessLevel} />
        <Route exact path="/access-levels/create" component={CreateOrEditAccessLevel} />
        <Route exact path="/staffs" component={Staff} />
        <Route exact path="/staffs/edit/:id" component={CreateOrEditStaff} />
        <Route exact path="/staffs/create" component={CreateOrEditStaff} />
        <Route exact path="/staff-report" component={StaffReport} />

        {/* Integrations */}
        <PrivateRoute exact path="/integrations/list" component={Integrations} />
        <Route exact path="/integrations/configs/:id?" component={NewIntegrations} />
        <Route exact path="/integrations/send-vouchers" component={SendVouchers} />
        <Route exact path="/integrations/vouchers" component={Vouchers} />
        <Route exact path="/integrations/invoices" component={Invoices} />
        <Route exact path="/integrations/configs/old/:id?" component={IntegrationConfigs} />
        <Route exact path="/integrations/gstock" component={GStock} />
        <Route path="/integrations/gstock/:id" component={GStock} />
        <Route exact path="/integrations/personalkollen" component={Personalkollen} />

        {/* Private routes */}
        <PrivateRoute exact path="/notification-logs" component={NotificationLogs} />
        <PrivateRoute exact path="/banking-dashboard" component={BankingDashboard} />
        <PrivateRoute exact path="/companies" component={Companies} />
        <PrivateRoute exact path="/companies/:id" component={Companies} />
        <PrivateRoute path="/companies/create" component={CreateCompany} />
        <PrivateRoute path="/companies/edit/:id" component={EditCompany} />
        <PrivateRoute exact path="/data" component={DataExtractor} />
        <PrivateRoute path="/tools/ordercreator" component={OrderCreator} />
        <PrivateRoute path="/tools/tableservice" component={TableService} />
        <PrivateRoute path="/revenue" component={Revenue} />
        <PrivateRoute exact path="/integrations/instagram" component={Integrations} />
        <PrivateRoute exact path="/integrations/facebook" component={Integrations} />
        <Route exact path="/devices/add" component={AddDevices} />
        <PrivateRoute exact path="/devices" component={Devices} />
        <PrivateRoute exact path="/printers" component={Printers} />
        <PrivateRoute exact path="/printers/debug" component={CloudPrintDebug} />
        <PrivateRoute path="/devices/create" component={CreateOrEditDevice} />
        <PrivateRoute path="/devices/edit/:id" component={CreateOrEditDevice} />
        <PrivateRoute path="/errors/integrations" component={IntegrationErrors} />
        <PrivateRoute path="/errors/invalid-orders" component={InvalidOrders} />
        <PrivateRoute path="/errors/invalid-refunds" component={InvalidRefunds} />
        <PrivateRoute exact path="/licenses" component={Licenses} />
        <PrivateRoute exact path="/migrate-licenses" component={MigrateLicenses} />
        <PrivateRoute exact path="/licenses/devices" component={ManageDevices} />
        <PrivateRoute exact path="/marketplaces" component={Marketplaces} />
        <PrivateRoute exact path="/tools/graveyard" component={Graveyard} />
        <PrivateRoute
          exact
          path="/tools/adyen-payouts-inspector"
          component={AdyenPayoutsInspector}
        />
        <PrivateRoute
          exact
          path="/tools/adyen-transactions-inspector"
          component={AdyenTransactionsInspector}
        />
        <PrivateRoute exact path="/tools/staff-extractor" component={StaffExtractor} />
        <PrivateRoute exact path="/tools/licenses-migration" component={MigrateLicensesStatus} />
        <Route exact path="/tools/data-comparison" component={DataComparison} />
        <PrivateRoute exact path="/tools/voucher-comparison" component={VoucherComparison} />
        <PrivateRoute exact path="/tools/companies-table" component={CompaniesTable} />
        <PrivateRoute exact path="/create-company" component={CreateCompanyOnboarding} />
        <PrivateRoute exact path="/create-company/:id" component={CreateCompanyForm} />
        <PrivateRoute exact path="/reports-monitoring" component={ReportsExplorer} />
        <PrivateRoute exact path="/releases" component={Releases} />
        <PrivateRoute exact path="/releases/:id" component={ReleaseForm} />
        <PrivateRoute exact path="/choice-invite-codes" component={ChoiceInviteCodes} />
        <PrivateRoute exact path="/organizations" component={Organizations} />
        <PrivateRoute exact path="/tools/analytics-import" component={AnalyticsImport} />

        {/* Onboarding (Quick-Office based) */}
        <PrivateRoute
          exact
          path="/onboarding/manual-user-activation"
          component={ManualUserActivation}
        />
        <PrivateRoute exact path="/onboarding/monitoring" component={OnboardingMonitoring} />
        <PrivateRoute exact path="/onboarding-monitoring/:id" component={OnboardingMonitoring} />

        {/* Hidden pages */}
        <Route exact path="/membership-discount-toggle" component={MembershipDiscountToggle} />

        <Route exact path="/addlocations" component={AddLocations} />

        {/* Onboarding BETA */}
        <Route exact path="/onboarding-beta" component={Onboarding} />
        <Route exact path="/onboarding-beta/:path" component={Onboarding} />

        <Route exact path="/link" component={LoginLink} key={'loginLink'} />

        <Route component={FourOhFour} />
      </Switch>
    </Suspense>
  );
};

export default Routes;
